import { Component } from "@angular/core";
import { Router } from "@angular/router";

@Component({
    selector: "app-contact-admin",
    templateUrl: "./contact-admin.component.html",
    styleUrls: ["./contact-admin.component.less"],
    standalone: false
})
export class ContactAdminComponent {
  constructor(private router: Router) {}

  goToProjects() {
    this.router.navigate(["/projects"]);
  }
}
